import { Observable } from 'rxjs';

import { GroupsService } from '../../services/groups.service';
import { BaseProjectGroupDto, GroupDto } from '@api/backend-connector/models';
import {
  SmartPickerHandler,
  SmartPickerPage,
  defaultSmartPickerOptions,
} from 'src/app/components-form/smart-input-entity/smart-picker.handler';
import { UIProjectGroupsService } from 'src/app/services/ui-project-groups.service';

type GroupPickerContext = {
  projectId?: string;
  onlyAssignable?: boolean;
};

export class GroupPickerHandler extends SmartPickerHandler<GroupDto | BaseProjectGroupDto> {
  constructor(
    private groupsService: GroupsService,
    private uiProjectGroupService: UIProjectGroupsService,
    private context: GroupPickerContext,
  ) {
    super(defaultSmartPickerOptions);
  }

  override getItems(params: {
    offset?: number | undefined;
    limit?: number | undefined;
    query?: string;
    excludeIds: string[] | undefined;
  }): Observable<SmartPickerPage<GroupDto | BaseProjectGroupDto>> {
    if (this.context.projectId) {
      return this.uiProjectGroupService.listProjectGroups({
        id: this.context.projectId,
        query: params.query,
        canAssignWorkPackage: this.context.onlyAssignable,
        offset: params.offset,
        limit: params.limit,
        excludeIds: params.excludeIds,
      });
    }
    return this.groupsService.listGroups({
      query: params.query,
      canAssignWorkPackage: this.context.onlyAssignable,
      offset: params.offset,
      limit: params.limit,
      excludeIds: params.excludeIds,
    });
  }
}
